import i18n from '@/localisation/i18n';
import { HeaderInfo } from '@/UI/HeaderInfo';
import { motion } from 'framer-motion';
import { Trans } from 'react-i18next';

export const NewClient = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      className="w-full"
    >
      <HeaderInfo title={i18n.t('banner.addClient.title')} backUrl="/">
        <div className="mt-8 md:pr-4">
          <div className="text-lg">{i18n.t('new.client.text.1')}</div>
          <div className="mt-5 text-lg">{i18n.t('new.client.text.2')}</div>
          <div className="mt-5 text-lg">{i18n.t('new.client.text.3')}</div>
          <div className="mt-5 text-lg">{i18n.t('new.client.text.4')}</div>
          <ul className="steps steps-vertical mt-5">
            <li className="step">
              <div>
                <Trans
                  i18nKey="new.client.steps.1"
                  components={{
                    Link: (
                      <a
                        className="text-orange underline"
                        href="https://www.mind-health.app"
                        target="_blank"
                      />
                    ),
                  }}
                />
              </div>
            </li>
            <li className="step">{i18n.t('new.client.steps.2')}</li>
            <li className="step">{i18n.t('new.client.steps.3')}</li>
          </ul>
          <div className="mt-5 text-lg">{i18n.t('new.client.text.5')}</div>
        </div>
      </HeaderInfo>
    </motion.div>
  );
};
